import React from 'react';
import { useTranslation } from '../../../i18n/use-translation';
import { useViewModel } from './hook/use-view-model';
import { SupportLinkProps } from './type/props';

export const SupportLink = (props: SupportLinkProps) => {
  const { t } = useTranslation();
  const { linkClickHandler } = useViewModel();

  return (
    <a href="#" className={props.className} onClick={linkClickHandler}>
      {t('support')}
    </a>
  );
};
